import { render, staticRenderFns } from "./UpgradeFromLegacy.vue?vue&type=template&id=35c5ebbb"
import script from "./UpgradeFromLegacy.vue?vue&type=script&lang=js"
export * from "./UpgradeFromLegacy.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFromLegacy.vue?vue&type=style&index=0&id=35c5ebbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports